import BrowserStorageService from './BrowserStorageService';
import ScriptService from './ScriptService';

class TelemetryService
{
    gtagId = "";
    cookieStatus = "unsettled";

    constructor()
    {
        this.storageService = BrowserStorageService;
    };

    setCookieStatus(status)
    {
        this.cookieStatus = status;
    };

    getCookieStatus()
    {
        return this.cookieStatus;
    };

    isGtagCookieActive()
    {
        return this.storageService.hasCookie("gtagCookie");
    }
    
    allowCookies()
    {
        if (this.getCookieStatus() !== "allow") this.setCookieStatus("allow");
        if (this.storageService.getLocalStorageData("cookieStatus") !== "allow") this.storageService.setLocalStorageData("cookieStatus", "allow");

        if (!window.gtag || !this.isGtagCookieActive()) {
            this.appendTagManagerScript();
            this.executeAnalyticsScript();
            this.toggleGoogleAnalytics(false);
        }
    };

    appendTagManagerScript() 
    {
        const scriptTag = document.createElement("script");

        scriptTag.setAttribute("async", "");
        scriptTag.setAttribute("src", `https://www.googletagmanager.com/gtag/js?id=${this.gtagId}`);

        document.body.appendChild(scriptTag);
    };

    async executeAnalyticsScript()
    {
        await ScriptService.loadData(`/configuration/gaConfig.js`).catch(e => console.error(e));
    }

    declineCookies()
    {
        this.setCookieStatus("decline");
        this.storageService.setLocalStorageData("cookieStatus", "decline");

        this.toggleGoogleAnalytics(true);
        this.clearDomainCookies();
    };

    clearDomainCookies()
    {
        const cookies = document.cookie.split(";");

        for (let i = 0; i < cookies.length; i++)
        {
            const cookie = cookies[i];
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;

            let locationName = window.location.hostname;
            
            if (locationName.indexOf("www.") === 0)
            {
                locationName = locationName.replace("www.", "");
            }

            this.storageService.removeCookie(name, locationName);
        }
    };

    toggleGoogleAnalytics(value)
    {
        window[`ga-disable-${this.gtagId}`] = value;
    }

    init(gtagId, needsCookieAuth = true)
    {
        const cookieStatus = this.storageService.getLocalStorageData("cookieStatus");

        if (cookieStatus) this.setCookieStatus(cookieStatus);

        if (gtagId && (this.cookieStatus === "allow" || !needsCookieAuth))
        {
            this.gtagId = gtagId;
            this.allowCookies()
        } else if (this.cookieStatus === "decline") {
            this.declineCookies();
        } else if (this.cookieStatus === "unsettled" && (this.isGtagCookieActive() || window.gtag)) {
            this.clearDomainCookies();
        }

        return this.cookieStatus;
    };
};

export default  new TelemetryService();